"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/domains/assets");
var _Categories = _interopRequireDefault(require("./Categories"));
var _Labels = _interopRequireDefault(require("./Labels"));
var _CustomFields = _interopRequireDefault(require("./CustomFields"));
var styles = {
  "icon": "CustomerMetadata__icon__1eFWZ",
  "dropdown-icon": "CustomerMetadata__dropdown-icon__1fowq",
  "dropdownIcon": "CustomerMetadata__dropdown-icon__1fowq",
  "metadata-item": "CustomerMetadata__metadata-item__1rfCM",
  "metadataItem": "CustomerMetadata__metadata-item__1rfCM",
  "metadata-item-wrapper": "CustomerMetadata__metadata-item-wrapper__6kwbv",
  "metadataItemWrapper": "CustomerMetadata__metadata-item-wrapper__6kwbv",
  "extendable": "CustomerMetadata__extendable__GmS9B",
  "editable": "CustomerMetadata__editable__2RE1j",
  "metadata": "CustomerMetadata__metadata__2OWHW",
  "popover": "CustomerMetadata__popover__ozLWy",
  "metadata-row": "CustomerMetadata__metadata-row__38kip",
  "metadataRow": "CustomerMetadata__metadata-row__38kip"
}; 
require('./CustomerMetadata.css');
var CustomerMetadata = function CustomerMetadata(_ref) {
  var asset = _ref.asset;
  var canEdit = (0, _reactRedux.useSelector)(function (state) {
    return _assets.selectors.canShowEdition(state, asset);
  });
  var categories = asset.categories,
    labels = asset.labels,
    customFields = asset.customFields;
  var getMetadata = function getMetadata() {
    return [].concat((0, _toConsumableArray2.default)((categories === null || categories === void 0 ? void 0 : categories.length) > 0 || canEdit ? [/*#__PURE__*/_react.default.createElement(_Categories.default, {
      canEdit: canEdit,
      asset: asset
    })] : []), (0, _toConsumableArray2.default)((labels === null || labels === void 0 ? void 0 : labels.length) > 0 || canEdit ? [/*#__PURE__*/_react.default.createElement(_Labels.default, {
      canEdit: canEdit,
      asset: asset
    })] : []), (0, _toConsumableArray2.default)((customFields === null || customFields === void 0 ? void 0 : customFields.length) > 0 ? [/*#__PURE__*/_react.default.createElement(_CustomFields.default, {
      customFields: customFields
    })] : []));
  };
  var style = {
    '--elements': getMetadata().length
  };
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: styles.metadata,
    style: style
  }, getMetadata().map(function (element, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react.default.createElement("li", {
        key: index
      }, element)
    );
  }));
};
var _default = exports.default = CustomerMetadata;
//# sourceMappingURL=CustomerMetadata.js.map